import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'

import Select from 'components/Select'

import { statusChanged } from 'components/RequestStatus/actions'
import { updateUserData } from 'scenes/ClientDetail/actions'

import './style.scss'

export class FilterDropDown extends BaseComponent {

  constructor() {
    super()

    this.state = {
      types: [],
      workshops: [],
      companies: [],
      brokers: [],
      states: [],
      cities: []
    }

    this._bind('_renderFilters', '_onFilterChange')
  }

  _onFilterChange(filter_type, option) {
    if (this.props._filterUpdate) {
      this.props._filterUpdate(filter_type, option)
    }
  }

  _renderFilters(){
    const filters = this.props.filters.toJS()
    return (
          <div className="dropdown_filters-wrapper">
            <div className="Claims__filters">
              <div className="Claims__filters__block">
                <strong className="Claims__filters__block-title">Siniestro</strong>
                <div className="Claims__filters__block-fields">
                  <form>
                  <Select
                    label="Cliente individual o flotilla"
                    onChange={(option) => this._onFilterChange('ct', option)}
                    options={this.props.dataSets.client_types}
                    searchable={false}
                    value={filters.ct}
                    {...this.props.buttonProps}
                  />
                  </form>
                  <form>
                  <Select
                    label="Tipo de siniestro"
                    onChange={(option) => this._onFilterChange('t', option)}
                    options={this.props.dataSets.types}
                    searchable={false}
                    value={filters.t}
                    {...this.props.buttonProps}
                  />
                  </form>
                </div>
              </div>
              <div className="Claims__filters__block">
                <strong className="Claims__filters__block-title">Taller</strong>
                <div className="Claims__filters__block-fields">
                  <form>
                  <Select
                    label="Nombre del taller"
                    onChange={(option) => this._onFilterChange('ws', option)}
                    options={this.props.dataSets.workshops}
                    searchable={false}
                    value={filters.ws}
                    {...this.props.buttonProps}
                  />
                </form>
                </div>
              </div>
              <div className="Claims__filters__block">
                <strong className="Claims__filters__block-title">Seguro</strong>
                <div className="Claims__filters__block-fields">
                  <form>
                  <Select
                    label="Aseguradora"
                    onChange={(option) => this._onFilterChange('ic', option)}
                    options={this.props.dataSets.companies}
                    searchable={false}
                    value={filters.ic}
                    {...this.props.buttonProps}
                  />
                  </form>
                  <form>
                  <Select
                    label="Agente asegurador"
                    onChange={(option) => this._onFilterChange('ib', option)}
                    options={this.props.dataSets.brokers}
                    searchable={false}
                    value={filters.ib}
                    {...this.props.buttonProps}
                  />
                  </form>
                </div>
              </div>
              <div className="Claims__filters__block">
                <strong className="Claims__filters__block-title">Ubicación</strong>
                <div className="Claims__filters__block-fields">
                  <form>
                  <Select
                    label="Estado"
                    onChange={(option) => this._onFilterChange('s', option)}
                    options={this.props.dataSets.states}
                    searchable={false}
                    value={filters.s}
                    {...this.props.buttonProps}
                  />
                  </form>
                  <form>
                  <Select
                    label="Ciudad"
                    onChange={(option) => this._onFilterChange('c', option)}
                    options={this.props.dataSets.cities}
                    searchable={false}
                    value={filters.c}
                    {...this.props.buttonProps}
                  />
                  </form>
                </div>
              </div>
            </div>
          </div>
    )
  }

  render() {
    return (
      <div id="FilterDropDown" className="dropdown pop-control d-flex align-items-center justify-content-center">
        <button  id="dropdownMenuButton"
            className="btn btn-secondary dropdown-toggle"
            type="button" data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">Filtrar por</button>
        
        <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
          {this._renderFilters()}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserData: (user) => dispatch(updateUserData(user)),
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(null, mapDispatchToProps)(FilterDropDown)

FilterDropDown.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/scenes/Claims/components/FilterDropDown/index.js